import { defineStore } from 'pinia'
import { useApi } from '@/composables/useApi.js'

export const useDataStore = defineStore('data', {
  state: () => {
    return {
      types: {},
    }
  },
  getters: {},
  actions: {
    async clearCache() {
      this.types = {}
    },
    async getTypeOptions(optionGroup, disableAllOption = false, label = 'name', value = 'id', extras = [], forceRefresh = false) {
      const { api } = useApi()

      if (!forceRefresh && this.types[optionGroup] && this.types[optionGroup].length) {
        return this.types[optionGroup]
      }

      try {
        const { data } = await api.get('/types', {
          params: {
            filters: {
              group: optionGroup,
              active: true
            },
            orderBy: 'ordering:asc,name:asc'
          }
        })

        let options = data.map((type) => {
          let returnOption = {
            label: type[label],
            value: type[value],
          }

          extras.forEach((extra) => {
            if (extra.includes('.')) {
              const [parent, child] = extra.split('.')
              returnOption[child] = type[parent]?.[child]

              if (returnOption[child] === undefined) {
                returnOption[child] = false
              }

              return
            }

            returnOption[extra] = type[extra]
          })

          return returnOption
        })

        if (!disableAllOption) {
          options.unshift({
            label: 'All',
            value: null
          })
        }

        if (options.length) {
          this.types[optionGroup] = options
        }

        return options
      } catch (e) {
        console.log(e)
      }
    },
  },
  persist: {
    key: `${import.meta.env.VITE_STORE_PREFIX}-data`,
  },
})
